import React from "react";
import { connect } from 'react-redux';
import { Container, Row, Col } from "reactstrap";
import BadgeList from './BadgeList.jsx';
import BadgeLeaderboard from './BadgeLeaderboard.jsx';
import CertificateList from './../certificate/CertificateList.jsx';
import CertificateVerify from './../certificate/CertificateVerify.jsx';
import Avatar from './Avatar.jsx';
import GamificationSummaryWidget from './../gamification/GamificationSummaryWidget.jsx';

class Achievements extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    var translate = this.props.translate || {};
    var classrooms = [];
    if (window.admin && window.admin.state && window.admin.state.classrooms) {
      classrooms = window.admin.state.classrooms.filter(function (c) {
        return c.inclassroom !== undefined;
      });
    }

    return (
      <React.Fragment>
        {!this.props.embedded &&
        <div className="header bg-gradient-info pb-6 pt-5 pt-md-8">
          <Container fluid>
            <div className="header-body d-flex align-items-center">
              <Avatar
                user={this.props.user}
                size={72}
                styleOverride={{ border: '3px solid rgba(255,255,255,0.3)' }}
              />
              <div className="ml-3">
                <h1 className="text-white mb-0">
                  <i className="fas fa-award mr-2" />
                  {translate['conquistas'] || 'Conquistas'}
                </h1>
                <p className="text-white-50 mb-0">
                  {translate['suas_badges_e_certificados'] || 'Suas badges e certificados de conclusão'}
                </p>
              </div>
            </div>
          </Container>
        </div>
        }

        <Container className={this.props.embedded ? "mt-3" : "mt--6"} fluid>
          {/* Widget de Gamificação no topo */}
          <Row className="mb-3">
            <Col>
              <GamificationSummaryWidget userId={this.props.user.id} />
            </Col>
          </Row>
          <Row>
            <Col xl="8">
              <BadgeList userId={this.props.user.id} />
              <div className="mt-3">
                <CertificateList userId={this.props.user.id} />
              </div>
            </Col>
            <Col xl="4">
              {classrooms.length > 0 && (
                <BadgeLeaderboard classroomId={classrooms[0].id} />
              )}
              <div className="mt-3">
                <CertificateVerify />
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );

  }

}

export default connect(state => ({
  translate: state.translate,
  user: state.user,
  permission: state.permission
}))(Achievements);
